import React, { useRef } from "react";
import { connect } from "react-redux";
import { Formik } from "formik";
import { Form } from "react-bootstrap";

import {
  TextInput,
  FormFilter,
  SubmitSearchButton,
  ClearFiltersButton,
  Select,
  CurrencyInput,
  DateInput,
} from "components/forms";
import {
  fetchOpportunities,
  fetchAccountsListChoices,
  fetchLifeSettlementChoices,
  updateAccountFilters,
} from "actions";
import { oppportunityStatusChoices, productTypeChoices } from "../../constants";
import { managementChoicesSelector, productsSelector } from "../../reducers";
import WSelect from "../../components/forms/selects/WindowedSelect";
import { FaUser } from "react-icons/fa";

const OpportunitiesFilterForm = ({ currentFilters, ...props }) => {
  React.useEffect(() => {
    props.fetchLifeSettlementChoices();
    props.fetchAccountsListChoices();
  }, []);
  let initialValues = {};

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        await props.fetchOpportunities(values);
        setSubmitting(false);
      }}
    >
      {({ handleSubmit, resetForm }) => {
        return (
          <FormFilter title={"Opportunities Search"} onSubmit={handleSubmit}>
            <Form.Row>
              <TextInput label="Last Name" name="last_name" />
              <TextInput label="First Name" name="first_name" />
              <TextInput label="Policy Number" name="policy_number" />
            </Form.Row>
            <Form.Row>
              <Select
                label="Carrier"
                name="carrier_id"
                placeholder="Select Carrier"
                options={props.carrierChoices?.getChoices() || []}
              />
              <Select
                label="Product Type"
                name="product_type"
                placeholder="Select Product Type"
                options={productTypeChoices}
              />
              <Select
                label="Insured Lives"
                name="number_of_insured_lives"
                placeholder="Select Insured Lives"
                emptyValue={null}
                options={[
                  { value: 1, label: "Single" },
                  { value: 2, label: "Joint Survivor" },
                ]}
              />
            </Form.Row>
            <Form.Row>
              <WSelect
                label="Select Account"
                name="account_id"
                options={props.accountChoices?.getChoices() || []}
                placeholder="Select Account"
              />
              <CurrencyInput label="Face Amount (Min)" name="face_amount_min" />
              <CurrencyInput label="Face Amount (Max)" name="face_amount_max" />
            </Form.Row>
            <Form.Row>
              <Select
                label="Status"
                name="status"
                placeholder="Select Status"
                options={oppportunityStatusChoices}
                md={4}
              />
              <Select
                label="Sales Rep"
                name="sales_representative_id"
                placeholder="Select Sales Rep"
                options={props.salesRepChoices?.getChoices({ sortByLabel: true }) || []}
                icon={<FaUser />}
                md={4}
              />
              <Select
                label="National Account"
                name="national_account_id"
                placeholder="Select National Account"
                options={props.nationalAccountChoices?.getChoices({ sortByLabel: true }) || []}
              />
            </Form.Row>
            <SubmitSearchButton />
            <ClearFiltersButton onClick={resetForm} />
          </FormFilter>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = state => {
  const choices = managementChoicesSelector(state);
  return {
    carrierChoices: choices.carriers,
    accountChoices: choices.accounts,
    nationalAccountChoices: choices.national_accounts,
    salesRepChoices: choices.case_sales_representatives,
  };
};

export default connect(mapStateToProps, {
  fetchOpportunities,
  fetchLifeSettlementChoices,
  fetchAccountsListChoices,
})(OpportunitiesFilterForm);
